import { toast } from "react-toastify";
import { addDockToRoute } from "./AddDockToRoute";
import { DockForFtlRouteViewModel } from "../../../../ViewModel/DockForFtlRouteViewModel";
import { EditProjectContextProps } from "../../../EditProjectContext";
import { apiErrorNotificationToast } from "../../../../../Errors/apiErrorNotificationToast";
import { useAddPlantDock } from "./Hooks/useAddPlantDock";
import { AxiosError } from "axios";
import { MdmApiError } from "../../../../../Errors/MdmApiError";

export async function addDockInputOnClick(
  input: string,
  ftlRouteId: number,
  EditProjectContext: EditProjectContextProps
) {
  if (!input) {
    throw new Error("Plant GSDB.Dock Code field is required");
  }
  const { project } = EditProjectContext;
  const addPlantDockRequest = useAddPlantDock;

  async function addPlantDocks(plantDockCombination: string) {
    const plantDockCombinationReplacedTabByPeriod = plantDockCombination.replaceAll("\t", ".");
    const values = plantDockCombinationReplacedTabByPeriod.trim().split(" ");

    const responses: Array<DockForFtlRouteViewModel> = [];
    // eslint-disable-next-line no-restricted-syntax
    for await (const plantDock of values) {
      if (!plantDock.includes(".")) {
        throw new Error(
          "Bad Input. One of combination is not in correct format. Please use GSDB.Dock"
        );
      }

      const dockForFtlRouteViewModel = (await addPlantDockRequest(
        plantDock,
        project.ProjectId,
        ftlRouteId
      ).catch((error: AxiosError<MdmApiError>) =>
        apiErrorNotificationToast(error)
      )) as DockForFtlRouteViewModel;

      if (dockForFtlRouteViewModel.DockId !== undefined) {
        responses.push(dockForFtlRouteViewModel);
      }
    }

    addDockToRoute(ftlRouteId, responses, EditProjectContext);
  }

  await toast.promise(addPlantDocks(input), {
    pending: "Pending",
    error: {
      render({ data }: { data: any }) {
        return data?.message;
      },
    },
    success: `Added following Dock(s): ${input}`,
  });
}
